/* eslint-disable no-throw-literal */
import {
  STOCK_CHECK_PERIOD,
  STOCK_CHECK_PERIOD_STORE
} from './mutation-types'

export default {
  actions: {
    async [STOCK_CHECK_PERIOD] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/stock_check_period/judge_head_office', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    },
    async [STOCK_CHECK_PERIOD_STORE] ({dispatch, state, commit}, params = {}) {
      const res = await dispatch('apiGet', {url: '/stock/stock_check_period/judge_store', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stock-check-period.js